import React, { Component } from 'react'
import { getBoundingClientRect } from '../../../../utils/functions';
import { translate } from '../../../../utils/useful';
import SidebarView from '../../../SidebarView';
import StagesManager from '../../../StagesManager';
import Administrators from '../sideBar/Administrators';
import ChatSetting from '../sideBar/ChatSetting';
import GroupInfo from '../sideBar/GroupInfo';
import GroupType from '../sideBar/GroupType';
import ManageGroup from '../sideBar/ManageGroup';
import MessengerPermission from '../sideBar/MeesengerPermission';
import MembersList from '../sideBar/MembersList';
import Topics from '../sideBar/Topics';
import AddMembers from '../sideBar/AddMembers';
import GroupMedia from '../sideBar/GroupMedia';
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../../../stores/actionsList';
class GroupInformation extends Component {
    state = {
        showCollapse: null,
        active: false,
        selected: 0,
        checkBox: {},
        contextMenu: {},


        option: [
            { icon: "/assets/icons/manage-gray.svg", title: "{{lang}}messenger.Manage Group", color: "#444", key: "manage" },
            { icon: "/assets/icons/leave-red.svg", title: "{{lang}}messenger.Leave Group", color: "#E61515", key: "leave" },
        ],

        MessengerContextMenu: [
            { icon: "/assets/icons/messenger/reply.svg", title: "{{lang}}messenger.Reply" },
            { icon: "/assets/icons/messenger/copy.svg", title: "{{lang}}messenger.Copy" },
            { icon: "/assets/icons/messenger/edit.svg", title: "{{lang}}messenger.Edit" },
            { icon: "/assets/icons/messenger/pin.svg", title: "{{lang}}messenger.Pin" },
            { icon: "/assets/icons/messenger/forward.svg", title: "{{lang}}messenger.Forward" },
            { icon: "/assets/icons/messenger/select.svg", title: "{{lang}}messenger.Select" },
            { icon: "/assets/icons/messenger/trash.svg", title: "{{lang}}messenger.Delete" },
        ],
        media: {},
        medias: [
            { name: '{{lang}}messenger.Photos', icon: "/assets/icons/camera-blue.svg", key: 'image' },
            { name: '{{lang}}messenger.Video', icon: "/assets/icons/video-blue.svg", key: 'video' },
            { name: '{{lang}}messenger.File', icon: "/assets/icons/doc-blue.svg", key: 'file' },
            { name: '{{lang}}messenger.Music', icon: "/assets/icons/music-blue.svg", key: 'music' },
            { name: '{{lang}}messenger.Voice', icon: "/assets/icons/mic-blue.svg", key: 'voice' },
            { name: '{{lang}}messenger.Links', icon: "/assets/icons/link-blue.svg", key: 'links' },
        ],
    }

    componentDidMount = () => {
        let medias = this.state.medias
        medias.forEach(media => {
            this.filterMedia(media.key)
        });
        this.openSidebar()
        // document.addEventListener("mousedown", this.handleClickOutside);

    }

    openSidebar = () => {
        this.sidebarView.openSidebar()
    }

    openFirstView = () => {
        this.firstView.showView()
    }



    onClosed = () => {
        setTimeout(() => {
            this.props.setData('messengerInfo', !this.props.messengerInfo, 'Messenger')
        }, 200);
    }

    filterMedia = (key) => {
        console.log('messengers', this.props.messengers.messages)
        console.log('messengers', this.props.messenger)
        let media = this.state.media
        media[key] = []
        Object.values(this.props.messengers.messages).forEach(element => {
            console.log('keyha', element)
            element.forEach(prop => {
                console.log('ooko', prop[key] != null)
                if (prop.messenger == this.props.messenger._id && prop[key] != null) {
                    media[key].push(prop)
                }
            })
        });
        console.log('media is', media)
        this.setState({ media })
    }


    render() {
        let type = this.state.type
        return (
            <div ref={el => this.container = el} className='w-100 window-content-radius h-100 d-flex flex-column' >
                <div className="">
                    <SidebarView onClosed={this.onClosed} hight={"100%"} width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "calc(100% - 50px)", sm: "calc(100% - 50px)", md: '45%', lg: "35%", xl: "30%" }}>
                        <div className='w-100 h-100'>
                            {console.log('HEREEE')}
                            <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}>
                                <GroupInfo media={this.state.media} medias={this.state.medias} filterMedia={this.filterMedia} width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} isLoader={this.props.isLoader} removeUser={this.props.removeUser} changeStage={this.changePage} stage={0} stageName={'info'} colors={this.props.colors} />
                                <ManageGroup width={this.props.width} updateGroup={this.props.updateGroup} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'manage'} colors={this.props.colors} />
                                <GroupType width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'grouptype'} colors={this.props.colors} />
                                <ChatSetting width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'chatsetting'} colors={this.props.colors} />
                                <MessengerPermission width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'permission'} colors={this.props.colors} />
                                <Administrators width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'adminestators'} colors={this.props.colors} />
                                <MembersList width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'members'} colors={this.props.colors} />
                                <Topics topics={this.props.topics} setData={this.props.setData} setMessenger={this.props.setMessenger} width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'topic'} colors={this.props.colors} />
                                <AddMembers width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'add'} colors={this.props.colors} />
                                <GroupMedia media={this.state.media} medias={this.state.medias} filterMedia={this.filterMedia} width={this.props.width} language={this.props.language} myId={this.props.myId} messenger={this.props.messenger} changeStage={this.changePage} stage={1} stageName={'media'} colors={this.props.colors} />
                            </StagesManager>
                        </div>
                    </SidebarView>
                </div>
                {/* {this.state.showContextMenu && (
                    <div style={{ position: "fixed", top: this.state.contextMenu.yPos, left: this.state.contextMenu.xPos }}>
                        <div className='shadow-2 px-3 py-1 br-10 blur-bg' style={{ width: "150px" }}>
                            {this.state.MessengerContextMenu.map((prop, index) => {
                                return (
                                    <button className='flexcb w-100 py-2' style={{ borderBottom: "1px solid #eee" }}>
                                        <p>{prop.title}</p>
                                        <img width={22} src={prop.icon} />
                                    </button>
                                )
                            })}
                        </div>
                    </div>
                )} */}
            </div>
        )
    }
}

const mapStateToProps = state => ({ settings: state.settings, user: state.user, messengers: state.messengers })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GroupInformation);